import { ProcessCard } from "@/components/screen/global-components/process/ProcessCards";

export const useCaseProcessCards: ProcessCard[] = [
  {
    id: 1,
    title: "Order online",
    description:
      "Use our self-service order form to choose your language pair, upload your files, and pay to initiate a project for delivery within 24 hours.",
  },
  {
    id: 2,
    title: "Dual human translate and proof",
    description:
      "Two native-speaking linguists experienced in your industry and use case will translate and edit your project while built-in quality assurance validates for accuracy.",
  },
  {
    id: 3,
    title: "Deliver and review",
    description:
      "We deliver your digital article translation in the layout or format specified for your approval, ensuring satisfaction with unlimited free revisions.",
  },
];
